/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationValueDto } from './CreateEnumerationValueDto';
import {
    CreateEnumerationValueDtoFromJSON,
    CreateEnumerationValueDtoFromJSONTyped,
    CreateEnumerationValueDtoToJSON,
} from './CreateEnumerationValueDto';
import type { CreateNumericValueDto } from './CreateNumericValueDto';
import {
    CreateNumericValueDtoFromJSON,
    CreateNumericValueDtoFromJSONTyped,
    CreateNumericValueDtoToJSON,
} from './CreateNumericValueDto';

/**
 * 
 * @export
 * @interface CreateBeamShapingGroupRectangularDto
 */
export interface CreateBeamShapingGroupRectangularDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    id: string;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    radiationFieldShape?: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    radiationFieldSymmetry?: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    radiationFieldSizeX?: CreateNumericValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    radiationFieldSizeY?: CreateNumericValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    radiationFieldEdgeX1?: CreateNumericValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    radiationFieldEdgeX2?: CreateNumericValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    radiationFieldEdgeY1?: CreateNumericValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    radiationFieldEdgeY2?: CreateNumericValueDto;
    /**
     * 
     * @type {string}
     * @memberof CreateBeamShapingGroupRectangularDto
     */
    $type?: CreateBeamShapingGroupRectangularDtoTypeEnum;
}


/**
 * @export
 */
export const CreateBeamShapingGroupRectangularDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamShapingGroupRectangularDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupRectangularDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateBeamShapingGroupRectangularDtoTypeEnum = typeof CreateBeamShapingGroupRectangularDtoTypeEnum[keyof typeof CreateBeamShapingGroupRectangularDtoTypeEnum];



/**
 * Check if a given object implements the CreateBeamShapingGroupRectangularDto interface.
 */
export function instanceOfCreateBeamShapingGroupRectangularDto(value?: unknown): value is CreateBeamShapingGroupRectangularDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateBeamShapingGroupRectangularDtoTypeEnum)[0];
}

export function CreateBeamShapingGroupRectangularDtoFromJSON(json: any): CreateBeamShapingGroupRectangularDto {
    return CreateBeamShapingGroupRectangularDtoFromJSONTyped(json, false);
}

export function CreateBeamShapingGroupRectangularDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBeamShapingGroupRectangularDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'radiationFieldShape': json['radiationFieldShape'] == null ? undefined : CreateEnumerationValueDtoFromJSON(json['radiationFieldShape']),
        'radiationFieldSymmetry': json['radiationFieldSymmetry'] == null ? undefined : CreateEnumerationValueDtoFromJSON(json['radiationFieldSymmetry']),
        'radiationFieldSizeX': json['radiationFieldSizeX'] == null ? undefined : CreateNumericValueDtoFromJSON(json['radiationFieldSizeX']),
        'radiationFieldSizeY': json['radiationFieldSizeY'] == null ? undefined : CreateNumericValueDtoFromJSON(json['radiationFieldSizeY']),
        'radiationFieldEdgeX1': json['radiationFieldEdgeX1'] == null ? undefined : CreateNumericValueDtoFromJSON(json['radiationFieldEdgeX1']),
        'radiationFieldEdgeX2': json['radiationFieldEdgeX2'] == null ? undefined : CreateNumericValueDtoFromJSON(json['radiationFieldEdgeX2']),
        'radiationFieldEdgeY1': json['radiationFieldEdgeY1'] == null ? undefined : CreateNumericValueDtoFromJSON(json['radiationFieldEdgeY1']),
        'radiationFieldEdgeY2': json['radiationFieldEdgeY2'] == null ? undefined : CreateNumericValueDtoFromJSON(json['radiationFieldEdgeY2']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateBeamShapingGroupRectangularDtoToJSON(value?: CreateBeamShapingGroupRectangularDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'radiationFieldShape': CreateEnumerationValueDtoToJSON(value['radiationFieldShape']),
        'radiationFieldSymmetry': CreateEnumerationValueDtoToJSON(value['radiationFieldSymmetry']),
        'radiationFieldSizeX': CreateNumericValueDtoToJSON(value['radiationFieldSizeX']),
        'radiationFieldSizeY': CreateNumericValueDtoToJSON(value['radiationFieldSizeY']),
        'radiationFieldEdgeX1': CreateNumericValueDtoToJSON(value['radiationFieldEdgeX1']),
        'radiationFieldEdgeX2': CreateNumericValueDtoToJSON(value['radiationFieldEdgeX2']),
        'radiationFieldEdgeY1': CreateNumericValueDtoToJSON(value['radiationFieldEdgeY1']),
        'radiationFieldEdgeY2': CreateNumericValueDtoToJSON(value['radiationFieldEdgeY2']),
        '$type': value['$type'],
    });
}

